import $ from 'jquery';
import { debounce } from 'lodash';

import Monitoring from 'shared_modules/Monitoring';

const DiscountRules = (): DiscountRules => {
  const DEBOUNCE_RATE_MS = 125;
  const DIRTY_CLASS_NAME = 'dirty';

  const addAllItemsButtonSelector = '#addAllItemsButton';
  const addApplyItemSearchSelector = '#view_add_apply_item_search';
  const addItemButtonSelector = '#addItemButton';
  const addMultiCategoryIdSelector = '#view_add_multi_category_id';
  const addMultiExcludeTags = '#view_add_multi_exclude_tags';
  const addMultiTagsSelector = '#view_add_multi_tags';

  const makeButtonDirty = ({ buttonSelector }: { buttonSelector: string }) =>
    $(buttonSelector).addClass(DIRTY_CLASS_NAME);

  // Single observer
  const addInputFieldObserver = (node: Node, callback: any) => {
    const inputObserver = new window.MutationObserver(inputMutations => {
      console.log(inputMutations);
      const { attributeName } = inputMutations[0];
      switch (attributeName) {
        case 'value':
          callback?.();
          break;
        default:
          break;
      }
    });

    try {
      inputObserver.observe(node, { attributes: true });
    } catch (error) {
      Monitoring.NRError(error, 'addInputFieldObserver', { node });
    }
  };

  const attachEventListeners = () => {
    $(addApplyItemSearchSelector).on(
      'keyup.discountRules',
      debounce(makeAddItemButtonDirty, DEBOUNCE_RATE_MS)
    );

    [$(addMultiTagsSelector), $(addMultiExcludeTags)].forEach(inputEl => {
      $(inputEl).on('keyup.discountRules', debounce(makeAddAllItemsButtonDirty, DEBOUNCE_RATE_MS));
    });
  };

  const attachMutationObservers = () => {
    const categoryEl = $(addMultiCategoryIdSelector);

    switch (categoryEl.get(0).nodeName) {
      case 'SELECT':
        $(categoryEl).on(
          'change.discountRules',
          debounce(makeAddAllItemsButtonDirty, DEBOUNCE_RATE_MS)
        );
        break;

      // Observe changes in JS trees like `field_tree_select`
      case 'INPUT':
        addInputFieldObserver(categoryEl.get(0), makeAddAllItemsButtonDirty);
        break;

      default:
        break;
    }
  };

  const makeAddAllItemsButtonDirty = () => {
    makeButtonDirty({
      buttonSelector: addAllItemsButtonSelector,
    });
  };

  const makeAddItemButtonDirty = () => {
    makeButtonDirty({
      buttonSelector: addItemButtonSelector,
    });
  };

  const attachEvents = () => {
    window.setTimeout(() => {
      attachEventListeners();
      attachMutationObservers();
    }, 0);
  };

  return {
    attachEvents,
    makeAddAllItemsButtonDirty,
    makeAddItemButtonDirty,
  };
};

export default DiscountRules;

window.merchantos.discountRules = DiscountRules();
